<div>
    <div *ngIf="editable">
        <!-- newKeyword not in use at the moment -->
        <!-- <p *ngIf="keywordPanel"><b>Schlagworte zur Suchoptimierung</b></p> -->
        <h3 *ngIf="!keywordPanel">Stärken des Produkts</h3>
        <div class="auto-min">
            <mat-form-field class="fullWidth">
                <!-- <input *ngIf="keywordPanel" matInput placeholder="Schlagwort" [(ngModel)]="newKeyword"
                    (keyup.enter)="addKeyword()" /> -->
                    <mat-label>Produktstärken</mat-label>
                    <input matInput (ngModelChange)="limitToTwoWords()"
                        [(ngModel)]="newKeyword" (keyup.enter)="addKeyword()" />
                    <mat-hint>(Bis zu 10 Begriffe, jeweils 2 Wörter)</mat-hint>
            </mat-form-field>
            <div class="plus-button">
                <green-plus-button (press)="addKeyword()"></green-plus-button>
            </div>
        </div>
    </div>
    <div class="keywordsPanel">
        <div *ngFor="let keyword of keywords; let last = last" class="container">
            <div class="keywordCardWrapper">
                <!-- <div
                    *ngIf="editable"
                    class="deleteBtn"
                    (click)="removeKeyword(keyword)"
                >
                    <div class="stripe"></div>
                </div> -->
                <div class="keywordCard">
                    <p class="keyword">{{ keyword }}</p>
                </div>
                <red-cross-button-circle *ngIf="editable" (click)="removeKeyword(keyword)"></red-cross-button-circle>
            </div>

            <span *ngIf="!keywordPanel && !last"> / </span>
        </div>
    </div>
</div>
